export const READINESS_KEYS = ["sore", "stress", "energy", "mood", "sleep"];

// A client with fewer earlier questionnaires than this is still "learning" their normal
export const BASELINE_MIN_CHECK_INS = 7;

// 6 weeks, counting the day being judged (same window as the mobile helper)
export const BASELINE_WINDOW_DAYS = 42;

// Whether a day's own questionnaire is part of its normal. The product owner chose to leave it
// out (2026-10-20): a very bad day must not pull its own range down and hide. Mobile does the same.
export const INCLUDE_CURRENT_IN_NORMAL = false;

// A question whose period average fell by at least this much "drove the change"
export const QUESTION_DROP_THRESHOLD = 0.4;

// Session RPE on below-normal days has to beat the other days by this much to be worth saying
export const RPE_GAP_MIN = 0.5;

// "The lowest in the last N months" needs at least this much history
export const LATEST_LOWEST_MIN_MONTHS = 2;

export const MAX_INSIGHTS = 5;

// A total is the sum of five answers of 1 to 5; a single answer is 1 to 5
export const TOTAL_MIN = 5;
export const TOTAL_MAX = 25;
export const ANSWER_MIN = 1;
export const ANSWER_MAX = 5;

export const DAYS_PER_MONTH = 30.44;
